import type { FaireProductEntity } from "../../entity_types/product";

export const p_2xr86ba768: FaireProductEntity = {
  token: "p_2xr86ba768",
  type: "product",
  name: "BOAT NECK DOLMAN SLEEVE SWEATER TOP",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/e3f0a9c82c4e35288908788ffa298403855f46f0a0f1dd2229b061d1abe5deda.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b91e888d4069eb5358e5be44e4aa0003b0fddcf8f7ab692f5b528098745e8d65.jpeg",
    "https://cdn.faire.com/fastly/74a8930bd4e06d2def0ebf556c5e85ce60414edb72684aeddcbd9ae7883fa52d.jpeg",
    "https://cdn.faire.com/fastly/42010e2c53278fdd65395b82333e1ceccfe88ba0d6f4b84d2862d6b8068b59a5.jpeg",
    "https://cdn.faire.com/fastly/6eb584cf58a83c9971737bf980e8dddae8ff1637248a24d3be04ba1e4b97ee7e.jpeg",
    "https://cdn.faire.com/fastly/cd19ea19554fb5eebf34f6a6cccbc298c89db98a58b7313056a32425aa42c16a.jpeg",
    "https://cdn.faire.com/fastly/e0e8b5e14abb149558545cfe3d2dd62d4c04869918ff8e7173e1f5250c65c102.jpeg",
    "https://cdn.faire.com/fastly/da4dd81bbd875ffc3058fb3f231db4aada39cebf8a71145997462a39945ae9d3.jpeg",
    "https://cdn.faire.com/fastly/e49f9d489ce0e0c6cfb6073d5d2a40e56dbd1e91d1b989ba2d85282dc2732034.jpeg",
    "https://cdn.faire.com/fastly/68b7367197d7b14a312fa2f4ef863aa6da1478d480ed907c7d66809b5ee8e447.jpeg",
    "https://cdn.faire.com/fastly/5f6a7f03ebc9cac5f62dda28dd19cd0b9f8f105a0d68873e800150475ce09422.jpeg",
    "https://cdn.faire.com/fastly/1a85723e64079f29355e1b99638ae8c9e976fbd8c771f775b26cdc829788e172.jpeg",
    "https://cdn.faire.com/fastly/b82d98f23447910911b0c40c0b7b77809f43a025b9a619b93d77409c150644fa.jpeg",
    "https://cdn.faire.com/fastly/ce959f8efbbfdd6d5852f8a092a69dda652c1e88f9b27dd3b34ccf2008500751.jpeg",
    "https://cdn.faire.com/fastly/44c662c017e170ad01ab1b24318f69cd9240002cd021632f7d8ae5213fb8b4c3.jpeg",
    "https://cdn.faire.com/fastly/84a18885a0bb06ff54424ba597f065e9b603cde45a6d8145ab0dd92371dacd8f.jpeg",
    "https://cdn.faire.com/fastly/39dbbe90b96cc91f31fb330cb5098c966c88096b164347a9f9168c98657bf10e.jpeg",
    "https://cdn.faire.com/fastly/38bf84a787137c440b1b624c62a62a09b4bd1a8965636dcd708f4d9f5d76cd4c.jpeg",
    "https://cdn.faire.com/fastly/0c282f92eba5a2acd6e97019df6abd053dd40832c72c5344c6ea0821a23a1c07.jpeg",
    "https://cdn.faire.com/fastly/f3928f6f18d2454dbfeada73a8bfd857321f923f01860e31e9587917a1857d34.jpeg",
    "https://cdn.faire.com/fastly/3a739d80c31f3d7c892d59015c6914afccbc9f544467d7b54bf7c3f58920eab9.jpeg",
    "https://cdn.faire.com/fastly/c6f3e2f71103482c7587ade44883686bc778553da565b13a3fd0ac884847d4db.jpeg",
    "https://cdn.faire.com/fastly/eabff934474f42e634cfa6532c0c10423533ba53fcc89e5d165658bd3b010ecb.jpeg",
    "https://cdn.faire.com/fastly/d6dbfb611d299151fabed6f4bba5ea64ec406809d677cb0c28daabb305518c7f.jpeg",
    "https://cdn.faire.com/fastly/2edf0601cd1e0fdbde0f3178a48fbf8f6457784aea6e61ee8dd09460f6872a39.jpeg",
    "https://cdn.faire.com/fastly/2ba36df544027f01bbbf9f1076c16e9b99972315c746caa08154ad849eefbfff.jpeg",
    "https://cdn.faire.com/fastly/c3d8871ae113131a52cef6d4f4204fd3d32c8f7d9d8c15cb2e977d0282e060d9.jpeg",
    "https://cdn.faire.com/fastly/c198d32ade572024b99ea3b7e9c4fa92f3eb8d22a603ba723ea532ad0c47c75a.jpeg",
  ],
  priceDollars: 162,
  description:
    'Model is wearing a size small.\n\n𝗠𝗼𝗱𝗲𝗹 𝗦𝗽𝗲𝗰𝘀\n• Height: 5\'8"\n• Bust: 32A\n• Waist: 24"\n• Hips: 34"',
  tags: [],
  msrpDollars: 324,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:06.614Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
